import React, { useEffect, useState } from "react";
import "./terms.scss";
import FooterText from "../modules/FooterText";
const mbaList = [
  "Students admitted in the 1st year of 2-year full-time on campus MBA or its equivalent programs at selected institutions/colleges are eligible for this scholarship.",
  "Students pursuing 'Distance/Online/Part-time/Executive, integrated MBA program or any MBA program other than 2-year full-time MBA/PGDM program are not eligible for this scholarship.",
  "Final grant of Scholarships will take place only after due verification of their documents & on-ground screening of the shortlisted applicants. In case the applicant fails to do the needful in any of these stages or is unable to comply with the process within the stipulated timeframe, his/her candidature shall be rejected.",
  "The applicant needs to provide the details for on-ground verification as mentioned in the form to the bank representatives.",
  "The final disbursement of the scholarship will take place after submission of the fees receipt by the student-applicant.",
  "The amount of the scholarship is meant for covering the tuition fees and shall be disbursed in the account of the said institution/college of admission only. The students should contact the college administration if any reimbursement applicable, which will be the sole responsibility of the students.",
  "The final selection of awardees will be solely at the discretion of IDFC FIRST Bank.",
  "Scholarship availed can be recalled by the IDFC FIRST Bank if there is any misrepresentation from the Students.",
  "It is mandatory for the College to submit the Scholarship Acknowledgement Receipt against the payment made in the template shared by IDFC FIRST Bank CSR Team for each instalment.",
  "It is mandatory for the awardees to attend all IDFC FIRST Bank events pertaining to the IDFC FIRST Bank MBA Scholarship.",
  "It is mandatory for students to pass their first year and be promoted to second year to be eligible for second year of scholarship. For this, it is mandatory for the College to share the Passing certificate in the template shared by IDFC FIRST Bank CSR Team.",
  "Children of IDFC FIRST Bank employees are not eligible for the scholarship. If found, the candidature will be rejected at any given stage of scholarship process.",
  // "Disbursement of Scholarship amount is subject to the details provided by the student.",
  "Disbursement is subjected to the correct information provided by scholars & college post selection.",
];
const engList = [
  "Students admitted in the 1st year of 4-year full-time on campus Engineering or at selected institutions/colleges are eligible for this scholarship.",
  "Students pursuing 'Distance/Online program or any Diploma program other than 4-year full-time B.E. / B.Tech program are not eligible for this scholarship.",
  "Final grant of Scholarships will take place only after due verification of their documents & on-ground screening of the shortlisted applicants. In case the applicant fails to do the needful in any of these stages or is unable to comply with the process within the stipulated timeframe, his/her candidature shall be rejected.",
  "The applicant needs to provide the details for on-ground verification as mentioned in the form to the bank representatives.",
  "The final disbursement of the scholarship will take place after submission of the fees receipt by the student applicant.",
  "The amount of the scholarship is meant for covering the tuition fees and shall be disbursed in the account of the said institution/college of admission only. The students should contact the college administration if any reimbursement applicable, which will be the sole responsibility of the students.",
  "The final selection of awardees will be solely at the discretion of IDFC FIRST Bank.",
  "Scholarship availed can be recalled by the IDFC FIRST Bank if there is any misrepresentation from the Students.",
  "It is mandatory for the College to submit the Scholarship Acknowledgement Receipt against the payment made in the template shared by IDFC FIRST Bank CSR Team for each instalment.",
  "It is mandatory for the awardees to attend all IDFC FIRST Bank events pertaining to the IDFC FIRST Bank Engineering Scholarship.",
  "It is mandatory for students to pass their first year and be promoted to second year to be eligible for second year of scholarship & same condition is applicable till 4th year. For this, it is mandatory for the College to share the Passing certificate in the template shared by IDFC FIRST Bank CSR Team.",
  "Children of IDFC FIRST Bank employees are not eligible for the scholarship. If found, the candidature will be rejected at any given stage of scholarship process.",
  "Disbursement is subjected to the correct information provided by scholars & college post selection.",
];
function Terms() {
  const [type, setType] = useState(engList);
  useEffect(() => {
    let urlList = window.location.href
      .replace(/^(https?:\/\/)?(www\.)?/i, "")
      .split("/");

    console.log(
      "in terms",

      window.location.href.replace(/^(https?:\/\/)?(www\.)?/i, "").split("/")
    );
    if (!urlList[2] || urlList[2] === "eng") {
      setType(engList);
    } else {
      setType(mbaList);
    }
  }, []);
  return (
    <div className="form-div review terms">
      <div className="review-heading">
        <div className="form-title">Terms and Conditions</div>
      </div>
      <div className="info-text">
        <ul>
          {type.map((item, index) => {
            return (
              <li className="option-text" key={index}>
                {item}
              </li>
            );
          })}
        </ul>
        {/* <div className="agreement">
          <div className="form-title">Communication Policy Agreement</div>
          <div className="option-text">
            “I authorise the bank and/or its representatives, agents to
            communicate/ call/SMS/email me/us with respect to this application
            or any other promotional activities. I/We confirm that laws in
            relation to the unsolicited communication referred in “National Do
            Not Call Registry” as laid down by Telecom Regulatory of India will
            not be applicable for such communications/calls/ SMSs/emails
            received from the Bank, its representatives, agents. The Bank
            reserves the right to retain the photograph and documents submitted
            with the application and shall not return them back.”
          </div>
        </div> */}
      </div>
      <FooterText />
    </div>
  );
}

export default Terms;
